module.exports = __webpack_public_path__ + "assets/assets/images/illustrations/finance.1b7b48f3.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/illustrations/finance.png
// module id = 538
// module chunks = 0